import AssessmentTemplatesList from '@/views/shared/AssessmentTemplatesList'

function Create(){
  return <AssessmentTemplatesList title='pages.my_assessments.new_assessment'/>
}
export default Create;
